import { render, staticRenderFns } from "./QDormantStatuses.vue?vue&type=template&id=45fa8ca4&scoped=true&"
import script from "./QDormantStatuses.vue?vue&type=script&lang=js&"
export * from "./QDormantStatuses.vue?vue&type=script&lang=js&"
import style0 from "./QDormantStatuses.vue?vue&type=style&index=0&id=45fa8ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa8ca4",
  null
  
)

export default component.exports